export class OrderAction {
    static CUSTOMER_CANCEL = 'customer_cancel';    // Cancel order, from customer
    static PROVIDER_CANCEL = 'provider_cancel';    // Cancel order, from provider
    static PROVIDER_ISSUE = 'provider_issue';    // Provider have an issue with the vehicle
    static CUSTOMER_DISPUTE = 'customer_dispute';    // Customer has an issue with this order
}

Object.freeze(OrderAction);